// Mirrors src/util/menuItemType.ts on the server, which is what actually
// decides - this is only for previewing the id before saving.
export const RESERVED_MENU_ITEM_TYPES = [
  "deny",
  "undeny",
  "headpats",
  "credit",
  "adjustment",
  "other",
];

// Keeps a created item's Discord command ("tip-" + the id) within Discord's
// 32 character limit.
export const MAX_MENU_ITEM_TYPE_LENGTH = 28;

export const slugifyMenuItemType = (name: string) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

// foot_rub -> "/tip-foot-rub", matching commandForType on the server.
export const slashCommandForType = (type: string) =>
  `/tip-${type.replace(/_/g, "-")}`;
